<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#496E2D;" cx="256" cy="256" r="256"/>
<circle style="fill:#D80027;" cx="200.348" cy="256" r="111.304"/>
</svg>